import Swiper, {Navigation, Mousewheel} from 'swiper';

Swiper.use([Navigation, Mousewheel]);

let swiper = new Swiper('.n-partners__items', {
    slidesPerView: 4,
    spaceBetween: 30,
    slidesPerGroup: 1,
    speed: 300,
    cssMode: true,
    loop: true,
    navigation: {
        nextEl: '.n-partners__button.n-partners__button--next',
        prevEl: '.n-partners__button.n-partners__button--prev',
    },
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        1280: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
    }
});

